import { Note } from '/@/modules/note/models/Note';
import { ModelCollection } from '/@/modules/core/app/models/ModelCollection';
import { ModelType } from '/@/modules/core/app/constants/ModelType';

export class NoteCollection extends ModelCollection {
  /**
   * @param {array} items
   */
  constructor(items = null) {
    super(items, Note);
  }

  /**
   * @param {array|NoteCollection|null} items
   * @returns {NoteCollection}
   */
  static mapModel(items = null) {
    return new this(items, Note);
  }

  /**
   * @returns {Note[]}
   */
  get estateNotes() {
    return this.items?.filter((item) => item.modelType === null) ?? [];
  }

  /**
   * @returns {Note[]}
   */
  get entityNotes() {
    return this.items?.filter((item) => item.modelType !== null);
  }

  /**
   * @returns {Note[]}
   */
  get assetNotes() {
    return this.items?.filter((item) => item.modelType === ModelType.ASSET) ?? [];
  }

  /**
   * @returns {Note[]}
   */
  get liabilityNotes() {
    return this.items?.filter((item) => item.modelType === ModelType.LIABILITY) ?? [];
  }

  /**
   * @returns {Note[]}
   */
  get documentNotes() {
    return this.items?.filter((item) => item.modelType === ModelType.DOCUMENT) ?? [];
  }

  get pinnedNotes() {
    return this.items?.filter((note) => note.isPinned);
  }

  /**
   * @returns {?Note}
   */
  get estatePrimaryNote() {
    return this.estateNotes?.[0];
  }
}
